<app-login-header></app-login-header>
<ng-container *ngIf="loading$ | async">
	<div class="overlay"></div>
	<mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </ng-container>
<div class="container page-content">
  <div class="template-detail">
    <div class="header mb-3">Login to your account</div>
    <form [formGroup]="loginForm" class="example-form">

      <div class="mb-3">
        <div class="col-sm-12">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="userId">UserId :</mat-label>
            <input matInput formControlName="userId" class="form-control" [errorStateMatcher]="matcher" required
              class="form-control">
            <!-- <mat-error *ngIf="loginForm.get('userId')?.hasError('required')">User Id is required</mat-error> -->

          </mat-form-field>
          <div class="error-messages">
            <ng-container *ngFor="let error of error_messages.userId">
              <mat-error class="error-message"
                *ngIf="loginForm.get('userId')?.hasError(error.type) && (loginForm.get('userId')?.dirty || loginForm.get('userId')?.touched)">
                {{ error.message }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-form-field class="example-full-width" appearance="outline">

            <mat-label class="form-label" for="password">Password :</mat-label>
            <input matInput formControlName="password" class="form-control" [errorStateMatcher]="matcher" required
              class="form-control" maxlength="50" type="password">

          </mat-form-field>
          <div class="error-messages">
            <ng-container *ngFor="let error of error_messages.password">
              <mat-error class="error-message"
                *ngIf="loginForm.get('password')?.hasError(error.type) && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
                {{ error.message }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>
      <form [formGroup]="captchaForm" (ngSubmit)="onSubmit()">
        <div style="display: flex; align-items: center; "  >
          <img [src]="captchaImage" alt="CAPTCHA">
          <mat-form-field appearance="outline" style="padding-left: 20px;" >
            <mat-label for="captchaInput">Enter CAPTCHA:</mat-label>
            <input style="width: 100px !important;" matInput id="captchaInput" formControlName="captchaInput" required>
          </mat-form-field>

        </div>
        <div>

        </div>
      </form>
      <mat-error>{{loginFailedMessage}}</mat-error>

      <div class="d-flex justify-content-between mb-4 mt-4">
        <a mat-button href="javascript:void(0)" (click)="onForgotPassword()">Forgot Password?</a>
        <button mat-raised-button type="button" id="submit" class="btn btn-primary" [disabled]="loginForm.invalid"
          (click)="onSubmit()">SIGN IN</button>
      </div>
    </form>

  </div>
</div>
<!-- <app-captcha></app-captcha> -->
<app-footer></app-footer>